import { m } from 'framer-motion';
import { GameState } from '@brainfart/shared';

interface WaitingScreenProps {
  game: GameState;
  hostName?: string;
  onLeave: () => void;
}

export function WaitingScreen({ game, hostName, onLeave }: WaitingScreenProps) {
  const inProgress = game.phase !== 'ended' && game.phase !== 'final';
  const round = Math.min(game.currentRound + 1, game.settings.rounds);
  const here = game.players.filter(p => p.connected);

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}
    >
      <div className="card" style={{ width: '100%', maxWidth: 420, textAlign: 'center', padding: '2.5rem 1.5rem' }}>
        <m.div
          animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 1 }}
          style={{ fontSize: '3rem', marginBottom: '1rem' }}
        >
          ⏳
        </m.div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#FFC93C', marginBottom: '0.5rem' }}>
          You're in for the next game
        </h1>
        <p style={{ color: '#aaa', marginBottom: '1.5rem' }}>
          {inProgress
            ? `A game is underway (question ${round} of ${game.settings.rounds}).`
            : 'The last game just wrapped up.'}{' '}
          {hostName ? `${hostName} will start the next one.` : 'The host will start the next one.'}
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', justifyContent: 'center', marginBottom: '2rem' }}>
          {here.map(p => (
            <span
              key={p.id}
              style={{
                padding: '0.35rem 0.75rem',
                borderRadius: '100px',
                background: '#1B1830',
                border: `1px solid ${p.color}`,
                fontSize: '0.85rem',
                color: '#ddd',
              }}
            >
              {p.avatar} {p.name}
            </span>
          ))}
        </div>

        <button className="btn btn-ghost" onClick={onLeave}>
          Leave
        </button>
      </div>
    </m.div>
  );
}
